<template>
  <div
    class="grid-col grid-col_33 grid-col_lg-50 pt-32 pt-md-8"
    v-for="item in this.getVariants"
    :key="item"
  >
    <BundleTypeItem :item="item" />
  </div>
</template>

<script>
import BundleTypeItem from "./BundleTypeItem.vue";
import { useBundleStore } from "@/sleep_bundle/stores/bundle";
import { mapState } from "pinia";

export default {
  name: "BundleTypeList",
  components: { BundleTypeItem },
  computed: {
    ...mapState(useBundleStore, ["getVariants"]),
  }
};
</script>
